// Logical-group endpoints. Groups + members (area targets) — both
// list + create; no group-detail endpoint (the panel selects inline).

import { request, type ApiResponse } from "../client";
import type {
  LogicalGroupCreate,
  LogicalGroupMemberCreate,
  LogicalGroupMemberOut,
  LogicalGroupOut,
} from "../types/logicalGroup";

function base(a: string, t: string, s: string): string {
  return `/api/v1/accounts/${encodeURIComponent(a)}/tenants/${encodeURIComponent(
    t,
  )}/sites/${encodeURIComponent(s)}/logical-groups`;
}

export const logicalGroups = {
  list: (
    a: string,
    t: string,
    s: string,
  ): Promise<ApiResponse<LogicalGroupOut[]>> =>
    request<LogicalGroupOut[]>("GET", base(a, t, s)),

  create: (
    a: string,
    t: string,
    s: string,
    body: LogicalGroupCreate,
  ): Promise<ApiResponse<LogicalGroupOut>> =>
    request<LogicalGroupOut>("POST", base(a, t, s), body),

  listMembers: (
    a: string,
    t: string,
    s: string,
    groupSlug: string,
  ): Promise<ApiResponse<LogicalGroupMemberOut[]>> =>
    request<LogicalGroupMemberOut[]>(
      "GET",
      `${base(a, t, s)}/${encodeURIComponent(groupSlug)}/members`,
    ),

  createMember: (
    a: string,
    t: string,
    s: string,
    groupSlug: string,
    body: LogicalGroupMemberCreate,
  ): Promise<ApiResponse<LogicalGroupMemberOut>> =>
    request<LogicalGroupMemberOut>(
      "POST",
      `${base(a, t, s)}/${encodeURIComponent(groupSlug)}/members`,
      body,
    ),
};
